<template>
  <table class="table table-sm extable">
    <thead>
      <tr>
        <th>Дата и время</th>
        <th>Источник</th>
        <th>Задача</th>
        <th class="extable__num">Расходники</th>
        <th class="extable__num">Работа без учёта расходников</th>
        <th class="extable__num">Прочие расходы</th>
        <th class="extable__num">Итог</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="rows.length === 0">
        <td colspan="7" class="text-muted text-center py-3 extable__empty">За выбранный период расходов нет</td>
      </tr>
      <tr v-for="row in rows" :key="row.key" class="extable__row" :class="'extable__row--' + row.kind" :data-key="row.key">
        <td class="extable__when">{{ row.when }}</td>
        <td class="extable__source">{{ row.source }}<div v-if="row.description" class="extable__description" :title="row.descriptionTitle || null">{{ row.description }}</div></td>
        <td class="extable__task">{{ row.taskId ? 'T‑' + row.taskId : '—' }}</td>
        <td class="extable__num">{{ cell(row.consumables) }}</td>
        <td class="extable__num">{{ cell(row.works) }}</td>
        <td class="extable__num">{{ cell(row.other) }}</td>
        <td class="extable__num extable__total">{{ cell(row.total) }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { formatRubCell } from '@/components/management/dispatcher/format';

/** Dumb table of merged expense rows (KOP-39 spec §6.5). Rows come pre-sorted from expensesLogic.buildRows. */
export default {
  name: 'ExpensesTable',
  props: {
    rows: { type: Array, default: () => [] },
  },
  methods: {
    cell: (v) => formatRubCell(v),
  },
};
</script>

<style scoped lang="scss">
.extable { margin-bottom: 0; font-size: 13px; }
.extable th { font-weight: 600; color: #4c524d; white-space: nowrap; border-top: 0; }
.extable__num { text-align: right; white-space: nowrap; }
.extable__when { white-space: nowrap; }
.extable__description { color: #8b918c; font-size: 12px; }
.extable__total { font-weight: 600; }
.extable__row--manual .extable__source { color: #1d221f; }
</style>
